<nb-toggle [formControl]="control" status="success">{{
    (
    control.value
    ? Config.labels.on_label
    : Config.labels.off_label
    ) || Config.labels.label
    }}</nb-toggle>